@file:OptIn(InternalResourceApi::class)

package ifaandroid.apps.bland.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/ifaandroid.apps.bland.composeapp.generated.resources/"

@delegate:ResourceContentHash(-236_759_913)
internal val Res.drawable.ic_checkmark_checked: DrawableResource by lazy {
      DrawableResource("drawable:ic_checkmark_checked", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_checkmark_checked.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_033_061_507)
internal val Res.drawable.ic_checkmark_unchecked: DrawableResource by lazy {
      DrawableResource("drawable:ic_checkmark_unchecked", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_checkmark_unchecked.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(448_507_211)
internal val Res.drawable.ic_play_12: DrawableResource by lazy {
      DrawableResource("drawable:ic_play_12", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_play_12.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_checkmark_checked", Res.drawable.ic_checkmark_checked)
  map.put("ic_checkmark_unchecked", Res.drawable.ic_checkmark_unchecked)
  map.put("ic_play_12", Res.drawable.ic_play_12)
}
